var _rect, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 80,
    height: 80,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8112 58.2048L46.6935 13.9317C45.2969 11.4699 42.7952 10 40.0016 10C37.2081 10 34.7064 11.4699 33.3097 13.9317L8.19214 58.2047C6.79533 60.6667 6.79533 63.6063 8.19214 66.0683C9.58895 68.5302 12.0904 70 14.8841 70H65.1191C67.9126 70 70.4143 68.5301 71.8112 66.0684C73.208 63.6063 73.208 60.6667 71.8112 58.2048ZM68.477 64.1095C67.7761 65.3448 66.5208 66.0822 65.1191 66.0822H14.8841C13.4823 66.0822 12.227 65.3448 11.5262 64.1095C10.8255 62.8741 10.8255 61.3992 11.5262 60.1639L36.644 15.8908C37.3448 14.6555 38.6 13.918 40.0017 13.918C41.4033 13.918 42.6587 14.6555 43.3594 15.8908L68.4771 60.1639C69.1778 61.3992 69.1778 62.8741 68.477 64.1095Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 53.0596C38.585 53.0596 37.4336 54.2313 37.4336 55.6716C37.4336 57.1119 38.585 58.2836 40.0003 58.2836C41.4155 58.2836 42.567 57.1119 42.567 55.6716C42.567 54.2313 41.4156 53.0596 40.0003 53.0596Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9858 28.8545C41.2246 28.8545 42.1914 29.8086 42.1914 31.5001C42.1914 36.6609 41.7685 44.0769 41.7685 49.2378C41.7684 50.5822 40.9525 51.1459 39.9857 51.1459C39.2606 51.1459 38.2334 50.5822 38.2334 49.2378C38.2334 44.077 37.8105 36.661 37.8105 31.5001C37.8105 29.8088 38.8074 28.8545 39.9858 28.8545Z",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.af43d3d749e4e75db234aa9301438843.svg";
export { ForwardRef as ReactComponent };